import React from 'react';
import { LoadingTripBoxes } from '../../components/loadingTripBoxes';
import { useFavoritesData } from '../../hooks/favorites/useFavoritesData';
import { useFavoritesNavigation } from '../../hooks/favorites/useFavoritesNavigation';
import { FavoritesHeader } from './FavoritesHeader';
import { FavoritesGrid } from './FavoritesGrid';
import { EmptyFavoritesState } from './EmptyFavoritesState';
import { FavoritesErrorState } from './FavoritesErrorState';

/**
 * Favorites page component - refactored to separate business logic from UI.
 * All business logic is now in custom hooks, making it reusable for React Native.
 */
export const FavoritesPage = React.memo(() => {
  // Business logic hooks (platform-agnostic)
  const { favoritesByYear, isLoading, error, hasFavorites, unfavoriteTrip } = useFavoritesData();

  // Web-specific navigation hook
  const { navigateToTrip } = useFavoritesNavigation();

  // Handlers
  const handleUnfollow = async (tripId: string, linkSecret: string | null, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    await unfavoriteTrip(tripId, linkSecret);
  };

  const handleNavigate = (url: string, e: React.MouseEvent) => {
    e.preventDefault();
    navigateToTrip(url);
  };

  return (
    <div className="min-h-screen bg-subtle">
      <FavoritesHeader />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        {isLoading && <LoadingTripBoxes />}

        {!isLoading && !hasFavorites && !error && <EmptyFavoritesState />}

        {!isLoading && hasFavorites && (
          <FavoritesGrid
            favoritesByYear={favoritesByYear}
            onUnfollow={handleUnfollow}
            onNavigate={handleNavigate}
          />
        )}

        {error && <FavoritesErrorState />}
      </div>
    </div>
  );
});
